import SUBSCRIPTION_TYPES from "../types/subscriptionTypes";

const initialState = {
  loading: false,
  submitting: false,
  error: null,
  subscriptionTypes: [],
  userSubsciptions: undefined,
  cancelSubscription: undefined,
  referrers: [],
};

export default function subscriptionReducer(state = initialState, action) {
  switch (action.type) {
    case SUBSCRIPTION_TYPES.CREATE_CUSTOMER_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };
    case SUBSCRIPTION_TYPES.CREATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case SUBSCRIPTION_TYPES.CREATE_CUSTOMER_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case SUBSCRIPTION_TYPES.FETCH_SUBSCRIPTION_TYPES_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SUBSCRIPTION_TYPES.FETCH_SUBSCRIPTION_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,
        subscriptionTypes: action.payload.data,
      };

    case SUBSCRIPTION_TYPES.FETCH_SUBSCRIPTION_TYPES_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case SUBSCRIPTION_TYPES.CHECKOUT_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };
    case SUBSCRIPTION_TYPES.CHECKOUT_SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case SUBSCRIPTION_TYPES.CHECKOUT_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case SUBSCRIPTION_TYPES.CREATE_SUBSCRIPTION_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };
    case SUBSCRIPTION_TYPES.CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case SUBSCRIPTION_TYPES.CREATE_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case SUBSCRIPTION_TYPES.FETCH_REFERRERS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SUBSCRIPTION_TYPES.FETCH_REFERRERS_SUCCESS:
      return {
        ...state,
        loading: false,
        referrers: action.payload.data,
      };
    case SUBSCRIPTION_TYPES.FETCH_REFERRERS_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case SUBSCRIPTION_TYPES.SUBMIT_REFERRER_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };
    case SUBSCRIPTION_TYPES.SUBMIT_REFERRER_SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case SUBSCRIPTION_TYPES.SUBMIT_REFERRER_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case SUBSCRIPTION_TYPES.SUBMIT_REFERRER_SUCCESS:
      return {
        ...state,
        submitting: false,
      };
    case SUBSCRIPTION_TYPES.SUBMIT_REFERRER_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    case SUBSCRIPTION_TYPES.FETCH_USER_SUBSCRIPTIONS_BEGIN: return {
      ...state,
      cancelSubscription:undefined,
      error: undefined
    }
    case SUBSCRIPTION_TYPES.FETCH_USER_SUBSCRIPTIONS_SUCCESS: return {
      ...state,
      userSubsciptions: action.payload.data,
    }
    case SUBSCRIPTION_TYPES.FETCH_USER_SUBSCRIPTIONS_FAILURE: return {
      ...state,
      userSubsciptions: undefined,
      error: action.payload.error
    }
    case SUBSCRIPTION_TYPES.CANCEL_SUBSCRIPTIONS_BEGIN:
      return {
        ...state,
        submitting: true,
        error: null,
      };
    case SUBSCRIPTION_TYPES.CANCEL_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        submitting: false,
        cancelSubscription: action.payload.data,
      };
    case SUBSCRIPTION_TYPES.CANCEL_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        submitting: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
